import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { FC, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  CabinetSizesSubType,
  CategoryType,
  CornerCabinetSizesSubType,
  UserType,
} from '../../api/appAPI'
import AdjLegSVG from '../../assets/adjLeg.svg?react'
import AdjLeg2SVG from '../../assets/adjLeg2.svg?react'
import CornerCabinetPng from '../../assets/cornerCabinet.png'
import DoubleDoorSVG from '../../assets/doubleDoor.svg?react'
import FivePiecesDoorSVG from '../../assets/fivePiecesDoor.svg?react'
import NewDoorSVG from '../../assets/newDoor.svg?react'
import ShakerDoorSVG from '../../assets/shakerDoor.svg?react'
import LeftDoorSVG from '../../assets/leftDoor.svg?react'
import NormalCabinetPng from '../../assets/normalCabinet.png'
import RightDoorSVG from '../../assets/rightDoor.svg?react'
import UnknownLegSVG from '../../assets/unknownLeg.svg?react'
import VGrooveDoorSVG from '../../assets/vGrooveDoor.svg?react'
import StandardDoorSVG from '../../assets/standardDoor.svg?react'
import LiftUpDoorSVG from '../../assets/liftUpDoor.svg?react'
import { ConfigsContext } from '../../common/configContext'
import {
  actions as appActions,
  chooseActualCabinetSizes,
} from '../../redux/appReducer'
import {
  CabinetProps,
  CabinetType,
  CornerCabinetProps,
  DoorHingeType,
  DoorType,
  DoorVisualType,
  DrawerSlideType,
  HandlePropsType,
  LegPropsType,
  actions as cabinetActions,
  handleTypes,
  knobHandleTypes,
  newDoorVisualTypeValues,
} from '../../redux/cabinetReducer'
import { StateType } from '../../redux/store'
import {
  HeightInputWithUnitSupport,
  HeightSelectWithUnitSupport,
  InputWithUnitSupport,
  SelectWithUnitSupport,
} from '../common/UnitComponents'
import { Flex, showMessage } from '../common/Helpers'
import { freedomCategoryId, minDepthOfCabByDrawerSlideType } from '../../config'
import { useSnackbar } from 'notistack'

interface ITypeButtonProps {
  title: string
  selectedType: string
  type: string
  children: JSX.Element
  size?: number
  childSize?: number
  disabled?: boolean

  setType(type: string): void
}

const TypeButton: FC<ITypeButtonProps> = ({
  title,
  selectedType,
  type,
  children,
  size,
  childSize,
  disabled,
  setType,
}) => {
  const selected =
    type === '#'
      ? selectedType.startsWith('#')
      : type === 'shaker'
        ? selectedType.startsWith('shaker')
        : selectedType === type

  return (
    <Tooltip title={title}>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: `${selected ? 3 : 2}px solid ${
            selected ? '#3f51b5' : '#616161'
          }`,
          borderRadius: 8,
          height: size ? size : 50,
          width: size ? size : 50,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        }}
        onClick={() => {
          if (!disabled) {
            setType(type)
          }
        }}
      >
        <Box
          style={{
            height: size ? size * 0.8 : 40,
            width: size ? size * 0.8 : 40,
          }}
        >
          {React.cloneElement(children, {
            width: '100%',
            height: '100%',
            viewBox: '0 0 100 100',
          })}
        </Box>
      </Box>
    </Tooltip>
  )
}

// interface ICabinetSizeProps {
//     name: string
//     value: number

//     onBlur(value: number): void
// }

// const CabinetSizeProp: FC<ICabinetSizeProps> = ({ name, onBlur, ...props }) => {

//     const [value, setValue] = useState(props.value)

//     useEffect(() => {
//         setValue(props.value)
//     }, [props.value])

//     return <FormControl variant="outlined" sx={{ mt: 2 }}>
//         <InputLabel>{name}</InputLabel>
//         <OutlinedInput
//             style={{ width: 120 }}
//             type='number'
//             label={name}
//             value={value}
//             onChange={(e) => {
//                 const pervValue = value
//                 let newValue = parseFloat(e.target.value)

//                 setValue(newValue)

//                 if (Math.abs(pervValue - newValue) === 1)
//                     onBlur(newValue)
//             }}
//             onBlur={() => { if (value !== props.value) onBlur(value) }}
//             onKeyUp={(e) => { if (e.key === 'Enter' && value !== props.value) onBlur(value) }}
//             onFocus={e => e.target.select()}
//             startAdornment={<InputAdornment position="start">cm</InputAdornment>}
//             inputProps={{ min: 0 }}
//         />
//     </FormControl>
// }

interface IProps {
  user: UserType | undefined
  sidebarHeight: number
  cabinetProps: CabinetProps
  cornerCabinetProps: CornerCabinetProps
  doorType: DoorType
  handleProps: HandlePropsType
  legPropsOn: boolean
  legType: LegPropsType['type']
  baseSubType: LegPropsType['baseSubType']
  baseLegCut: number
  splittedTop: boolean
  cabinetType: CabinetType
  panelVisualType: DoorVisualType
  actualCabinetSizes: CabinetSizesSubType
  actualCornerCabinetSizes: CornerCabinetSizesSubType
  actualCabinetTitle: string
  actualCabinetCategory: CategoryType | undefined
  categoriesList: CategoryType[]
  microvellumName: string
  isCorner: boolean
  drawerSlideType: DrawerSlideType
  doorHingeType: DoorHingeType
  isThereDrawer: boolean
  isInIframe: boolean

  setWidth(value: number, thickness: number): void
  setHeight(value: number, thickness: number, fromUI: boolean): void
  setDepth(value: number): void
  setDoorType(newType: DoorType): void
  setLegsOn(value: boolean): void
  setSplittedTop(value: boolean): void
  setHandlePosition(value: HandlePropsType['position']): void
  setHandleVisualType(value: HandlePropsType['type']): void
  setHandleSubType(value: HandlePropsType['subtype']): void
  setCabinetType(value: CabinetType): void
  setPanelVisualType(value: DoorVisualType): void
  setLegType(
    value: LegPropsType['type'],
    subType?: LegPropsType['subType'],
    baseSubType?: LegPropsType['baseSubType']
  ): void
  chooseActualCabinetSizes(setDefaults?: boolean): void
  setLegHeight(value: number, thickness: number): void
  setBaseLegCut(value: number): void
  setActualCabinetTitle(value: string): void
  setActualCabinetCategory(value: CategoryType | undefined): void
  setMicrovellumName(value: string): void
  setIsCorner(value: boolean): void
  setCornerCabinetType(value: CornerCabinetProps['type']): void
  setCHeight(value: number, thickness: number, fromUI: boolean): void
  setCWidth1(value: number): void
  setCWidth2(value: number): void
  setCDepth1(value: number): void
  setCDepth2(value: number): void
  setCBackWidth1(value: number): void
  setCBackWidth2(value: number): void
  setDrawerSlideType(v: DrawerSlideType): void
  setDoorHingeType(v: DoorHingeType): void
  makeFreedomCabinet(): void
}

const baseLegTypes: LegPropsType['type'][] = [
  'base',
  'baseIsland',
  'baseIsland2',
]

const CabinetSidebar: FC<IProps> = (props) => {
  // const setHandlePosition = (value: HandlePositionTypes) => { props.setHandlePosition(value) }
  const configs = useContext(ConfigsContext)
  const { enqueueSnackbar } = useSnackbar()

  const [isNewPanelVisualType, setIsNewPanelVisualType] = useState(
    props.panelVisualType.startsWith('#')
  )

  const [isShakerVisualType, setIsShakerVisualType] = useState(
    props.panelVisualType.startsWith('shaker')
  )

  const [isLegBase, setIsLegBase] = useState(
    baseLegTypes.includes(props.legType)
  )

  useEffect(() => {
    setIsNewPanelVisualType(props.panelVisualType.startsWith('#'))
    setIsShakerVisualType(props.panelVisualType.startsWith('shaker'))
  }, [props.panelVisualType])

  useEffect(() => {
    setIsLegBase(baseLegTypes.includes(props.legType))
  }, [props.legType])

  const [customSizes, setCustomSizes] = useState(false)

  useEffect(() => {
    const canMakeCustom =
      props.user?.role === 'admin' ||
      (props.user?.role === 'designer' &&
        props.user.refEmail === 'troy@garagecabinets.com')

    const isFreedomCabinet =
      props.actualCabinetCategory?.id === freedomCategoryId

    if (isFreedomCabinet) {
      setCustomSizes(true)
    } else if (!canMakeCustom) {
      setCustomSizes(false)
    }
  }, [props.actualCabinetCategory, props.user])

  const setIsCorner = (type: string) => {
    props.setIsCorner(type === 'corner')
    props.chooseActualCabinetSizes()
  }

  const handleDrawerSlideTypeChange = (t: DrawerSlideType) => {
    const minDepth = minDepthOfCabByDrawerSlideType[t]

    if (minDepth > props.cabinetProps.depth) {
      showMessage(
        enqueueSnackbar,
        `Minimum depth of the cabinet for ${t} slide is ${minDepth}cm`,
        'error'
      )

      return
    }

    props.setDrawerSlideType(t)
  }

  return (
    <Box
      p={2}
      style={{
        overflowY: 'auto',
        height: props.sidebarHeight - 16 * 2, //padding 2
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Button
        onClick={() => {
          const freedomCategory = props.categoriesList.find(
            (c) => c.id === freedomCategoryId
          )

          if (freedomCategory) {
            props.setIsCorner(false)
            props.makeFreedomCabinet()
            props.setActualCabinetCategory(freedomCategory)
            props.chooseActualCabinetSizes()
            props.setMicrovellumName('WS-Mega')
          } else {
            showMessage(enqueueSnackbar, 'Freedom category not found', 'error')
          }
        }}
        variant="contained"
        color="primary"
      >
        Freedom Cabinet
      </Button>
      <Box display="flex" columnGap={2} mt={2} width={1}>
        <TextField
          label="Cabinet Title"
          variant="outlined"
          value={props.actualCabinetTitle}
          onChange={(e) =>
            props.setActualCabinetTitle(e.target.value.replace(/['"]/, ''))
          }
          style={{ width: '100%' }}
        />
        <FormControl variant="outlined" style={{ width: '100%' }}>
          <InputLabel>Select Category</InputLabel>
          <Select
            value={props.actualCabinetCategory?.name || 'None'}
            // onChange={e => {

            // }}
            label="Select Category"
          >
            <MenuItem
              value="None"
              onClick={() => {
                props.setActualCabinetCategory(undefined)
                props.chooseActualCabinetSizes()
              }}
            >
              None
            </MenuItem>
            {props.categoriesList
              .filter((c) => c.forCorner === props.isCorner)
              .map((c) => (
                <MenuItem
                  key={c.id}
                  value={c.name}
                  onClick={() => {
                    props.setActualCabinetCategory(c)
                    props.chooseActualCabinetSizes()
                  }}
                >
                  {c.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>

      <TextField
        label="Microvellum Name"
        variant="outlined"
        disabled={!(props.user?.role === 'admin')}
        value={props.microvellumName}
        onChange={(e) =>
          props.setMicrovellumName(e.target.value.replace(/['"#]/, ''))
        }
        style={{ width: '60%', marginTop: 15 }}
      />

      <Box
        my={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
      >
        <Grid container spacing={2}>
          <Grid item xs={4}>
            {' '}
          </Grid>
          <Grid
            item
            xs={4}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Typography style={{ fontSize: 20 }}>Cabinet Type</Typography>
          </Grid>
          <Grid
            item
            xs={4}
            container
            justifyContent="flex-end"
            alignItems="center"
          >
            {props.actualCabinetCategory?.id !== freedomCategoryId && (
              <Box
                mt={2}
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-evenly',
                }}
              >
                <TypeButton
                  title="Normal"
                  size={35}
                  selectedType={props.isCorner ? 'corner' : 'normal'}
                  type="normal"
                  setType={setIsCorner}
                >
                  <img src={NormalCabinetPng} alt="" />
                </TypeButton>
                <TypeButton
                  title="Corner"
                  size={35}
                  selectedType={props.isCorner ? 'corner' : 'normal'}
                  type="corner"
                  setType={setIsCorner}
                >
                  <img src={CornerCabinetPng} alt="" />
                </TypeButton>
              </Box>
            )}
          </Grid>
        </Grid>
        <FormControl component="fieldset">
          <RadioGroup
            row
            value={props.cabinetType}
            onChange={(e) => {
              props.setCabinetType(e.target.value as CabinetType)
              props.chooseActualCabinetSizes()
            }}
          >
            <FormControlLabel
              value="base"
              control={<Radio color="primary" />}
              label="Base"
            />
            <FormControlLabel
              value="tall"
              control={<Radio color="primary" />}
              label="Tall"
            />
            <FormControlLabel
              value="upper"
              control={<Radio color="primary" />}
              label="Upper"
            />
            <FormControlLabel
              value="upperOpen"
              control={<Radio color="primary" />}
              label="Upper Open"
            />
            {/* {props.user?.email === 'xgagik8@gmail.com' && !props.isCorner && (
              <FormControlLabel
                value="advanced"
                control={<Radio color="primary" />}
                label="Advanced"
              />
            )} */}
          </RadioGroup>
        </FormControl>
        {props.isCorner && (
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={props.cornerCabinetProps.type}
              onChange={(e) => {
                props.setCornerCabinetType(
                  e.target.value as CornerCabinetProps['type']
                )
              }}
            >
              <FormControlLabel
                value="angled"
                control={<Radio color="primary" />}
                label="Angled"
              />
              <FormControlLabel
                value="2door"
                control={<Radio color="primary" />}
                label="2 Door"
              />
            </RadioGroup>
          </FormControl>
        )}
      </Box>

      {/* <CabinetProp name='Width' prop={props.cabinetProps.width} set={(prop: CabinetPropsValue) => { props.setWidth(prop, configs.thickness) }} />
            <CabinetProp name='Height' prop={props.cabinetProps.height} set={(prop: CabinetPropsValue) => { props.setHeight(prop, configs.thickness) }} />
            <CabinetProp name='Depth' prop={props.cabinetProps.depth} set={props.setDepth} /> */}
      {props.isCorner ? (
        <Box width={1}>
          <Box sx={{ display: 'flex', width: 1, columnGap: 2 }}>
            {customSizes ? (
              <InputWithUnitSupport
                label={
                  props.cornerCabinetProps.type === '2door'
                    ? 'Width 1'
                    : 'Width'
                }
                valueInCm={props.cornerCabinetProps.width1}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setCWidth1(v)
                }}
              />
            ) : (
              props.actualCornerCabinetSizes.width1.values.length > 0 && (
                <SelectWithUnitSupport
                  label={
                    props.cornerCabinetProps.type === '2door'
                      ? 'Width 1'
                      : 'Width'
                  }
                  valueInCm={props.cornerCabinetProps.width1}
                  valuesInCm={props.actualCornerCabinetSizes.width1.values}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCWidth1(v)
                  }}
                />
              )
            )}
            {customSizes ? (
              <InputWithUnitSupport
                label={
                  props.cornerCabinetProps.type === '2door'
                    ? 'Depth 1'
                    : 'Depth'
                }
                valueInCm={props.cornerCabinetProps.depth1}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setCDepth1(v)
                }}
              />
            ) : (
              props.actualCornerCabinetSizes.depth1.values.length > 0 && (
                <SelectWithUnitSupport
                  label={
                    props.cornerCabinetProps.type === '2door'
                      ? 'Depth 1'
                      : 'Depth'
                  }
                  valueInCm={props.cornerCabinetProps.depth1}
                  valuesInCm={props.actualCornerCabinetSizes.depth1.values}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCDepth1(v)
                  }}
                />
              )
            )}
            {customSizes ? (
              <InputWithUnitSupport
                label={
                  props.cornerCabinetProps.type === '2door'
                    ? 'Back Width 1'
                    : 'Back Width'
                }
                valueInCm={props.cornerCabinetProps.backWidth1}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setCBackWidth1(v)
                }}
              />
            ) : (
              props.actualCornerCabinetSizes.backWidth1.values.length > 0 && (
                <SelectWithUnitSupport
                  label={
                    props.cornerCabinetProps.type === '2door'
                      ? 'Back Width 1'
                      : 'Back Width'
                  }
                  valueInCm={props.cornerCabinetProps.backWidth1}
                  valuesInCm={props.actualCornerCabinetSizes.backWidth1.values}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCBackWidth1(v)
                  }}
                />
              )
            )}
          </Box>
          {props.cornerCabinetProps.type === '2door' && (
            <Box sx={{ display: 'flex', width: 1, columnGap: 2, mt: 2 }}>
              {customSizes ? (
                <InputWithUnitSupport
                  label="Width2"
                  valueInCm={props.cornerCabinetProps.width2}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCWidth2(v)
                  }}
                />
              ) : (
                props.actualCornerCabinetSizes.width2.values.length > 0 && (
                  <SelectWithUnitSupport
                    label="Width2"
                    valueInCm={props.cornerCabinetProps.width2}
                    valuesInCm={props.actualCornerCabinetSizes.width2.values}
                    setValueInCm={(v) => {
                      console.log(v)

                      props.setCWidth2(v)
                    }}
                  />
                )
              )}
              {customSizes ? (
                <InputWithUnitSupport
                  label="Depth 2"
                  valueInCm={props.cornerCabinetProps.depth2}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCDepth2(v)
                  }}
                />
              ) : (
                props.actualCornerCabinetSizes.depth2.values.length > 0 && (
                  <SelectWithUnitSupport
                    label="Depth 2"
                    valueInCm={props.cornerCabinetProps.depth2}
                    valuesInCm={props.actualCornerCabinetSizes.depth2.values}
                    setValueInCm={(v) => {
                      console.log(v)

                      props.setCDepth2(v)
                    }}
                  />
                )
              )}
              {customSizes ? (
                <InputWithUnitSupport
                  label="Back Width 2"
                  valueInCm={props.cornerCabinetProps.backWidth2}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCBackWidth2(v)
                  }}
                />
              ) : (
                props.actualCornerCabinetSizes.backWidth2.values.length > 0 && (
                  <SelectWithUnitSupport
                    label="Back Width 2"
                    valueInCm={props.cornerCabinetProps.backWidth2}
                    valuesInCm={
                      props.actualCornerCabinetSizes.backWidth2.values
                    }
                    setValueInCm={(v) => {
                      console.log(v)

                      props.setCBackWidth2(v)
                    }}
                  />
                )
              )}
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              width: 1,
              columnGap: 2,
              justifyContent: 'center',
              mt: 2,
            }}
          >
            {customSizes ? (
              <HeightInputWithUnitSupport
                corner
                cabHeight={props.cornerCabinetProps.height}
                legHeight={props.cornerCabinetProps.legHeight}
                // width='30%'
                label="Height"
                valueInCm={
                  props.cornerCabinetProps.height +
                  props.cornerCabinetProps.legHeight
                }
                valuesInCm={props.actualCornerCabinetSizes.height.values}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setCHeight(v, configs.thickness, true)
                }}
              />
            ) : (
              props.actualCornerCabinetSizes.height.values.length > 0 && (
                <HeightSelectWithUnitSupport
                  corner
                  cabHeight={props.cornerCabinetProps.height}
                  legHeight={props.cornerCabinetProps.legHeight}
                  // width='30%'
                  label="Height"
                  valueInCm={
                    props.cornerCabinetProps.height +
                    props.cornerCabinetProps.legHeight
                  }
                  valuesInCm={props.actualCornerCabinetSizes.height.values}
                  setValueInCm={(v) => {
                    console.log(v)

                    props.setCHeight(v, configs.thickness, true)
                  }}
                />
              )
            )}
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', width: 1, columnGap: 2 }}>
          {customSizes ? (
            <InputWithUnitSupport
              label="Width"
              valueInCm={props.cabinetProps.width}
              setValueInCm={(v) => {
                console.log(v)

                props.setWidth(v, configs.thickness)
              }}
            />
          ) : (
            props.actualCabinetSizes.width.values.length > 0 && (
              <SelectWithUnitSupport
                label="Width"
                valueInCm={props.cabinetProps.width}
                valuesInCm={props.actualCabinetSizes.width.values}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setWidth(v, configs.thickness)
                }}
              />
            )
          )}
          {customSizes ? (
            <HeightInputWithUnitSupport
              cabHeight={props.cabinetProps.height}
              legHeight={props.cabinetProps.legHeight}
              label="Height"
              valueInCm={
                props.cabinetProps.height + props.cabinetProps.legHeight
              }
              valuesInCm={props.actualCabinetSizes.height.values}
              setValueInCm={(v) => {
                console.log(v)

                props.setHeight(v, configs.thickness, true)
              }}
            />
          ) : (
            props.actualCabinetSizes.height.values.length > 0 && (
              <HeightSelectWithUnitSupport
                cabHeight={props.cabinetProps.height}
                legHeight={props.cabinetProps.legHeight}
                label="Height"
                valueInCm={
                  props.cabinetProps.height + props.cabinetProps.legHeight
                }
                valuesInCm={props.actualCabinetSizes.height.values}
                setValueInCm={(v) => {
                  console.log(v)

                  props.setHeight(v, configs.thickness, true)
                }}
              />
            )
          )}
          {customSizes ? (
            <InputWithUnitSupport
              label="Depth"
              valueInCm={props.cabinetProps.depth}
              setValueInCm={(v) => {
                console.log(v)
                if (!props.isThereDrawer) {
                  props.setDepth(v)
                } else {
                  const actualMinDepth =
                    minDepthOfCabByDrawerSlideType[props.drawerSlideType]

                  if (actualMinDepth > v) {
                    showMessage(
                      enqueueSnackbar,
                      `Minimum depth of the cabinet for drawer ${props.drawerSlideType} slide is ${actualMinDepth}cm`,
                      'error'
                    )
                    return
                  }

                  props.setDepth(v)
                }
              }}
            />
          ) : (
            props.actualCabinetSizes.depth.values.length > 0 && (
              <SelectWithUnitSupport
                label="Depth"
                valueInCm={props.cabinetProps.depth}
                valuesInCm={props.actualCabinetSizes.depth.values}
                setValueInCm={(v) => {
                  console.log(v)
                  if (!props.isThereDrawer) {
                    props.setDepth(v)
                  } else {
                    const actualMinDepth =
                      minDepthOfCabByDrawerSlideType[props.drawerSlideType]

                    if (actualMinDepth > v) {
                      showMessage(
                        enqueueSnackbar,
                        `Minimum depth of the cabinet for drawer ${props.drawerSlideType} slide is ${actualMinDepth}cm`,
                        'error'
                      )
                      return
                    }

                    props.setDepth(v)
                  }
                }}
              />
            )
          )}
        </Box>
      )}

      {(props.user?.role === 'admin' ||
        (props.user?.role === 'designer' &&
          props.user.refEmail === 'troy@garagecabinets.com')) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography>Custom Sizes</Typography>
          <Switch
            checked={customSizes}
            onChange={(e) => {
              setCustomSizes(e.currentTarget.checked)
            }}
            color="primary"
          />
        </Box>
      )}

      <Typography style={{ fontSize: 20, marginTop: 15 }}>Door Type</Typography>

      <Box
        mt={2}
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <TypeButton
          title="Right"
          selectedType={props.doorType}
          type="right"
          setType={props.setDoorType}
        >
          <LeftDoorSVG />
        </TypeButton>
        <TypeButton
          title="Left"
          selectedType={props.doorType}
          type="left"
          setType={props.setDoorType}
        >
          <RightDoorSVG />
        </TypeButton>
        {!props.isCorner && (
          <>
            <TypeButton
              title="Double"
              selectedType={props.doorType}
              type="double"
              setType={props.setDoorType}
            >
              <DoubleDoorSVG />
            </TypeButton>
          </>
        )}
        <TypeButton
          title="Lift Up"
          selectedType={props.doorType}
          type="liftUp"
          setType={props.setDoorType}
        >
          <LiftUpDoorSVG />
        </TypeButton>
      </Box>

      {
        <>
          <Typography style={{ fontSize: 20, marginTop: 15 }}>
            Panel Visual Type
          </Typography>

          <Box
            mt={2}
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-evenly',
            }}
          >
            <TypeButton
              title="V-Groove"
              selectedType={props.panelVisualType}
              type="vGroove"
              setType={props.setPanelVisualType}
            >
              <VGrooveDoorSVG />
            </TypeButton>
            <TypeButton
              title="Five Pieces"
              selectedType={props.panelVisualType}
              type="fivePieces"
              setType={props.setPanelVisualType}
            >
              <FivePiecesDoorSVG />
            </TypeButton>
            <TypeButton
              title="New Types"
              selectedType={props.panelVisualType}
              type="#"
              setType={() => {
                props.setPanelVisualType(newDoorVisualTypeValues[0])
              }}
            >
              <NewDoorSVG />
            </TypeButton>
            <TypeButton
              title="Shaker"
              selectedType={props.panelVisualType}
              type="shaker"
              setType={() => props.setPanelVisualType('shaker_h')}
            >
              <ShakerDoorSVG />
            </TypeButton>
          </Box>

          {isNewPanelVisualType && (
            <FormControl sx={{ width: 200, mt: 3 }}>
              <InputLabel>New Door Visual Type</InputLabel>
              <Select
                defaultValue={newDoorVisualTypeValues[0]}
                value={props.panelVisualType}
                label={'New Door Visual Type'}
                onChange={(e) => {
                  props.setPanelVisualType(e.target.value as DoorVisualType)
                }}
              >
                {newDoorVisualTypeValues.map((v) => (
                  <MenuItem value={v} key={'dv' + v}>
                    {v}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {isShakerVisualType && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={props.panelVisualType[props.panelVisualType.length - 1]}
                onChange={(e) => {
                  props.setPanelVisualType(
                    ('shaker_' + e.target.value) as DoorVisualType
                  )
                }}
              >
                <FormControlLabel
                  value="h"
                  control={<Radio color="primary" />}
                  label="Horizontal"
                />
                <FormControlLabel
                  value="v"
                  control={<Radio color="primary" />}
                  label="Vertical"
                />
              </RadioGroup>
            </FormControl>
          )}
        </>
      }

      <Typography style={{ fontSize: 20, marginTop: 15 }}>
        Handle Visual Type
      </Typography>

      <Box
        mt={2}
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <TypeButton
          title="No Pull"
          selectedType={props.handleProps.type}
          type="noPull"
          setType={props.setHandleVisualType}
          disabled={props.isInIframe}
        >
          <LeftDoorSVG />
        </TypeButton>
        <TypeButton
          title="Pull"
          selectedType={props.handleProps.type}
          type="pull"
          setType={() => {
            props.setHandleVisualType('pull')
            props.setHandleSubType('standard')
          }}
          disabled={props.isInIframe}
        >
          <LeftDoorSVG />
        </TypeButton>
        <TypeButton
          title="Knob"
          selectedType={props.handleProps.type}
          type="knob"
          setType={() => {
            props.setHandleVisualType('knob')
            props.setHandleSubType('DHK301')
          }}
          disabled={props.isInIframe}
        >
          <LeftDoorSVG />
        </TypeButton>
      </Box>

      {props.handleProps.type === 'knob' && (
        <FormControl sx={{ width: 200, mt: 3 }} disabled={props.isInIframe}>
          <InputLabel>Knob Type</InputLabel>
          <Select
            defaultValue={knobHandleTypes[0]}
            value={props.handleProps.subtype}
            label={'Knob Type'}
            onChange={(e) => {
              props.setHandleSubType(
                e.target.value as HandlePropsType['subtype']
              )
            }}
          >
            {handleTypes.knob.map((v) => (
              <MenuItem value={v} key={'dv' + v}>
                {v}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {props.handleProps.type === 'pull' && (
        <FormControl sx={{ width: 200, mt: 3 }} disabled={props.isInIframe}>
          <InputLabel>Pull Type</InputLabel>
          <Select
            defaultValue={props.handleProps.subtype}
            value={props.handleProps.subtype}
            label={'Pull Type'}
            onChange={(e) => {
              props.setHandleSubType(
                e.target.value as HandlePropsType['subtype']
              )
            }}
          >
            {handleTypes.pull.map((v) => (
              <MenuItem value={v} key={'dv' + v}>
                {v}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {(!props.isCorner || props.cornerCabinetProps.type !== '2door') && (
        <>
          <Typography style={{ fontSize: 20, marginTop: 15 }}>
            Door Hinge Type
          </Typography>

          <Box
            mt={2}
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-evenly',
            }}
          >
            <TypeButton
              title="Standard"
              selectedType={props.doorHingeType}
              type="standard"
              setType={props.setDoorHingeType}
              disabled={props.isInIframe}
            >
              <LeftDoorSVG />
            </TypeButton>

            <TypeButton
              title="Soft"
              selectedType={props.doorHingeType}
              type="soft"
              setType={props.setDoorHingeType}
              disabled={props.isInIframe}
            >
              <LeftDoorSVG />
            </TypeButton>
          </Box>
        </>
      )}

      {!props.isCorner && (
        <>
          <Typography style={{ fontSize: 20, marginTop: 15 }}>
            Drawer Slide Type
          </Typography>

          <Box
            mt={2}
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-evenly',
            }}
          >
            <TypeButton
              title="Standard"
              selectedType={props.drawerSlideType}
              type="standard"
              setType={handleDrawerSlideTypeChange}
              disabled={props.isInIframe}
            >
              <LeftDoorSVG />
            </TypeButton>

            <TypeButton
              title="Soft"
              selectedType={props.drawerSlideType}
              type="soft"
              setType={handleDrawerSlideTypeChange}
              disabled={props.isInIframe}
            >
              <LeftDoorSVG />
            </TypeButton>

            <TypeButton
              title="Under Mount"
              selectedType={props.drawerSlideType}
              type="under_mount"
              setType={handleDrawerSlideTypeChange}
              disabled={props.isInIframe}
            >
              <LeftDoorSVG />
            </TypeButton>
          </Box>
        </>
      )}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid item xs={4}>
          {' '}
        </Grid>
        <Grid item xs={4} container justifyContent="center" alignItems="center">
          <Typography style={{ fontSize: 20 }}>Legs</Typography>
        </Grid>
        <Grid
          item
          xs={4}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          <Switch
            checked={props.legPropsOn}
            onChange={(e) => {
              props.setLegsOn(e.currentTarget.checked)
            }}
            color="primary"
            disabled={props.cabinetType !== 'advanced'}
          />
        </Grid>
      </Grid>

      {props.legPropsOn && (
        <Box
          mt={2}
          style={{
            display: 'grid',
            gap: 4,
            gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
            // width: '100%',
          }}
        >
          <TypeButton
            title="Toe Kick"
            selectedType={props.legType}
            type="base"
            setType={() =>
              props.setLegType('base', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <UnknownLegSVG />
          </TypeButton>

          <TypeButton
            title="Toe Kick Island"
            selectedType={props.legType}
            type="baseIsland"
            setType={() =>
              props.setLegType('baseIsland', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <UnknownLegSVG />
          </TypeButton>

          {!props.isCorner && (
            <TypeButton
              title="Toe Kick Island2"
              selectedType={props.legType}
              type="baseIsland2"
              setType={() =>
                props.setLegType('baseIsland2', undefined, props.baseSubType)
              }
              // disabled={props.isInIframe}
            >
              <UnknownLegSVG />
            </TypeButton>
          )}
          {!props.isCorner && (
            <TypeButton
              title="Standard No Toe Kick"
              selectedType={props.legType}
              type="noToeKick"
              setType={() =>
                props.setLegType('noToeKick', undefined, props.baseSubType)
              }
              // disabled={props.isInIframe}
            >
              <UnknownLegSVG />
            </TypeButton>
          )}
          <TypeButton
            title="Adjustable Cabinet Legs"
            selectedType={props.legType}
            type="standard"
            setType={() =>
              props.setLegType('standard', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <AdjLegSVG />
          </TypeButton>
          <TypeButton
            title="Adjustable Cabinet Legs 2 Short"
            selectedType={props.legType}
            type="standard2_1"
            setType={() =>
              props.setLegType('standard2_1', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <AdjLeg2SVG />
          </TypeButton>
          <TypeButton
            title="Adjustable Cabinet Legs 2 Tall"
            selectedType={props.legType}
            type="standard2_2"
            setType={() =>
              props.setLegType('standard2_2', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <AdjLeg2SVG />
          </TypeButton>
          {!props.isCorner && (
            <TypeButton
              title="Separate Base Platform"
              selectedType={props.legType}
              type="separateBase"
              setType={() =>
                props.setLegType('separateBase', undefined, props.baseSubType)
              }
              // disabled={props.isInIframe}
            >
              <UnknownLegSVG />
            </TypeButton>
          )}
          <TypeButton
            title="No Leg"
            selectedType={props.legType}
            type="noLeg"
            setType={() =>
              props.setLegType('noLeg', undefined, props.baseSubType)
            }
            // disabled={props.isInIframe}
          >
            <UnknownLegSVG />
          </TypeButton>
        </Box>
      )}

      {props.legPropsOn && isLegBase && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography>Inset</Typography>
          <Switch
            checked={props.baseSubType !== 'old'}
            onChange={(e) => {
              props.setLegType(
                props.legType,
                undefined,
                e.target.checked ? 'new' : 'old'
              )
            }}
            color="primary"
            // disabled={props.isInIframe}
          />
          <Typography>Notched</Typography>
        </Box>
      )}

      {
        props.legPropsOn && (
          <Flex gap={2}>
            <InputWithUnitSupport
              sx={{ mt: 2 }}
              label="Height"
              width={120}
              valueInCm={
                !props.isCorner
                  ? props.cabinetProps.legHeight
                  : props.cornerCabinetProps.legHeight
              }
              setValueInCm={(v) => props.setLegHeight(v, configs.thickness)}
              // disabled={props.isInIframe}
            />
            {props.legType === 'base' || props.legType === 'baseIsland' ? (
              <InputWithUnitSupport
                sx={{ mt: 2 }}
                label="Depth"
                width={120}
                valueInCm={props.baseLegCut}
                setValueInCm={(v) => props.setBaseLegCut(v)}
                // disabled={props.isInIframe}
              />
            ) : (
              <></>
            )}
          </Flex>
        )
        // <CabinetSizeProp
        //     name='Height'
        //     value={!props.isCorner ? props.cabinetProps.legHeight : props.cornerCabinetProps.legHeight}
        //     onBlur={(v) => props.setLegHeight(v, configs.thickness)}
        // />
      }
      {/* <FormControl variant="outlined" sx={{ mt: 2 }}>
                <InputLabel>Height</InputLabel>
                <OutlinedInput
                    style={{ width: 120 }}
                    type='number'
                    label={'Height'}
                    value={legHeight}
                    onChange={(e) => {
                        const pervValue = legHeight
                        let newValue = parseFloat(e.target.value)

                        // if (newValue > prop.max)
                        //     newValue = prop.max
                        // else if (newValue < prop.min)
                        //     newValue = prop.min

                        setLegHeight(newValue)

                        if (Math.abs(pervValue - newValue) === 1)
                            handleLegHeightBlur()
                    }}
                    onBlur={() => { handleLegHeightBlur() }}
                    onKeyUp={(e) => { if (e.key === 'Enter') handleLegHeightBlur() }}
                    onFocus={e => e.target.select()}
                    startAdornment={<InputAdornment position="start">cm</InputAdornment>}
                    inputProps={{ min: 0 }}
                />
            </FormControl>} */}

      {!props.isCorner && (
        <Grid container spacing={2} style={{ marginTop: 15 }}>
          <Grid item xs={4}>
            {' '}
          </Grid>
          <Grid
            item
            xs={4}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Typography style={{ fontSize: 20 }}>Splitted Top</Typography>
          </Grid>
          <Grid
            item
            xs={4}
            container
            justifyContent="flex-end"
            alignItems="center"
          >
            <Switch
              checked={props.splittedTop}
              onChange={(e) => {
                props.setSplittedTop(e.currentTarget.checked)
              }}
              color="primary"
              disabled={props.cabinetType !== 'advanced'}
            />
          </Grid>
        </Grid>
      )}

      {/* <Typography style={{ fontSize: 20, marginTop: 15 }}>Handle Position</Typography>
            <Box mt={2} style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-evenly'
            }}>
                <TypeButton
                    selectedType={typeof props.handlePosition === 'string' ? props.handlePosition : 'none'}
                    type='bottom'
                    setType={setHandlePosition}
                >
                    <BottomHandleSVG />
                </TypeButton>
                <TypeButton
                    selectedType={typeof props.handlePosition === 'string' ? props.handlePosition : 'none'}
                    type='center'
                    setType={setHandlePosition}
                >
                    <DoubleDoorSVG />
                </TypeButton>
                <TypeButton
                    selectedType={typeof props.handlePosition === 'string' ? props.handlePosition : 'none'}
                    type='top'
                    setType={setHandlePosition}
                >
                    <TopHandleSVG />
                </TypeButton>
            </Box> */}
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  user: state.appReducer.user,
  categoriesList: state.appReducer.categoriesList,
  actualCabinetTitle: state.appReducer.actualCabinetTitle,
  actualCabinetCategory: state.appReducer.actualCabinetCategory,
  sidebarHeight: state.appReducer.sidebarHeight,
  cabinetProps: state.cabinetReducer.props,
  doorType: state.cabinetReducer.doorType,
  handleProps: state.cabinetReducer.handleProps,
  legPropsOn: state.cabinetReducer.legProps.on,
  legType: state.cabinetReducer.legProps.type,
  baseSubType: state.cabinetReducer.legProps.baseSubType,
  baseLegCut: state.cabinetReducer.baseLegCut,
  splittedTop: state.cabinetReducer.splittedTop,
  cabinetType: state.cabinetReducer.cabinetType,
  doorVisualType: state.cabinetReducer.doorVisualType,
  panelVisualType: state.cabinetReducer.panelVisualType,
  actualCabinetSizes: state.appReducer.actualCabinetSizes,
  actualCornerCabinetSizes: state.appReducer.actualCornerCabinetSizes,
  microvellumName: state.appReducer.microvellumName,
  isCorner: state.cabinetReducer.isCorner,
  cornerCabinetProps: state.cabinetReducer.cornerProps,
  drawerSlideType: state.cabinetReducer.drawerSlideType,
  doorHingeType: state.cabinetReducer.doorHingeType,
  isThereDrawer: !!state.cabinetReducer.props.sectionProps.drawersProps.length,
  isInIframe: state.appReducer.isInIframe,
})

export default connect(mapStateToProps, {
  setWidth: cabinetActions.setWidth,
  setHeight: cabinetActions.setHeight,
  setDepth: cabinetActions.setDepth,
  setDoorType: cabinetActions.setDoorType,
  setHandlePosition: cabinetActions.setHandlePosition,
  setHandleVisualType: cabinetActions.setHandleVisualType,
  setHandleSubType: cabinetActions.setHandleSubType,
  setLegsOn: cabinetActions.setLegsOn,
  setLegType: cabinetActions.setLegType,
  setSplittedTop: cabinetActions.setSplittedTop,
  setCabinetType: cabinetActions.setCabinetType,
  setPanelVisualType: cabinetActions.setPanelVisualType,
  setLegHeight: cabinetActions.setLegHeight,
  setBaseLegCut: cabinetActions.setBaseLegCut,
  setIsCorner: cabinetActions.setIsCorner,
  setCornerCabinetType: cabinetActions.setCornerType,
  setActualCabinetTitle: appActions.setActualCabinetTitle,
  setActualCabinetCategory: appActions.setActualCabinetCategory,
  setMicrovellumName: appActions.setMicrovellumName,
  setCHeight: cabinetActions.setCHeight,
  setCWidth1: cabinetActions.setCWidth1,
  setCWidth2: cabinetActions.setCWidth2,
  setCDepth1: cabinetActions.setCDepth1,
  setCDepth2: cabinetActions.setCDepth2,
  setCBackWidth1: cabinetActions.setCBackWidth1,
  setCBackWidth2: cabinetActions.setCBackWidth2,
  setDrawerSlideType: cabinetActions.setDrawerSlideType,
  setDoorHingeType: cabinetActions.setDoorHingeType,
  makeFreedomCabinet: cabinetActions.makeFreedomCabinet,
  chooseActualCabinetSizes,
})(CabinetSidebar)
